var React = require('react');

function ChevronSmallUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"transform":"translate(-205 -252) translate(24 247) translate(181 5)"},React.createElement("g",null,React.createElement("path",{"d":"M6.364 0.6L7.778 2.014 2.829 6.964 7.778 11.914 6.364 13.328 0 6.964z","transform":"rotate(90 6 13)"})))))));
}

ChevronSmallUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronSmallUp;

ChevronSmallUp.default = ChevronSmallUp;
